export default {"src":"/_next/static/media/business-icon.fbac03a8.svg","height":16,"width":16};